/*
 * Module for the InputTokens control
*/
rs.module("ui/controls/input-tokens",

    [],

    function () {

        var _elements;
        var _textBoxes = [];

        function initialize(jsSelectors, textBoxJavascriptSelectors) {

            var inputTokens = $.js(jsSelectors.inputTokens);
            var tokens = $(inputTokens).js(jsSelectors.token, { multiple: true, required: false });

            textBoxJavascriptSelectors.forEach(textBoxJSSelector => { _textBoxes.push($.js(textBoxJSSelector)); });

            var focusedTextBox;

            if (tokens) {
                // replace spaces with _ then slice off surrounding { }
                _elements = $(tokens).map(function () { return $(this).text().replace(/\s/g, '_').slice(1, -1); }).get();

                // add token to focused textbox's cursor position
                $(tokens).click(function () {
                    if (!focusedTextBox) {
                        focusedTextBox = $(_textBoxes[0]);
                    }

                    var position = $(focusedTextBox).getCursorPosition();
                    var newCursorPos = position + $(this).text().length;

                    var text = $(focusedTextBox).val().substring(0, position) + $(this).text().replace(/\s/g, '_') + $(focusedTextBox).val().substring(position);

                    $(focusedTextBox)
                        .val(text)
                        .change()
                        .focus()
                        .selectRange(newCursorPos);

                    return false;
                });
            }

            _textBoxes.forEach(textBox => {
                // prevent tokens from showing as misspellings
                $(textBox).attr("spellcheck", "false");

                // turn off autocomplete to not get mixed up with our textcomplete
                $(textBox).attr("autocomplete", "off");

                // on focus of one of our token textboxes, set the focused box for adding tokens on click
                $(textBox).focus(function () {
                    focusedTextBox = this;
                });

                if (tokens) {
                    _applyTextcomplete(textBox);

                    _applyOverlay(textBox);
                }
            });

            // apply overlay styles to provided textbox
            function _applyOverlay(textBox) {
                var matchRegEx = '{(' + _elements.join("|") + ')}';

                // highlight tokens within textBox
                $(textBox).overlay([
                    {
                        match: new RegExp(matchRegEx, "g"),
                        css: {}
                    }
                ]);
            }

            // https://stackoverflow.com/questions/27757758/unable-to-setdata-of-undefined-to-allow-element-drag-and-drop
            $.event.addProp('dataTransfer');

            var isTokenDrag = false;
            // when dragging a token, replace the token's text whitespace with understores
            $(document).on("dragstart", function (event) {
                isTokenDrag = event.target.dataset.js === jsSelectors.token;
                if (isTokenDrag) {
                    event.dataTransfer.setData("text/plain", event.target.textContent.replace(/\s/g, '_'));
                }
            });

            var textBoxIds = $.map(_textBoxes, function (textBox) { return textBox[0].id; });
            // change cursor on dragging token over invalid textbox
            $(document).on('dragover', function (e) {
                if (isTokenDrag) {
                    var index = textBoxIds.indexOf(e.target.id);
                    if (index < 0) {
                        e.stopPropagation();
                        e.preventDefault();

                        e.originalEvent.dataTransfer.dropEffect = 'none';
                    }
                }
            });

            // on drop of a token, check that it is one of our textboxes, else prevent drop
            $(document).on("drop", function (event) {
                if (isTokenDrag) {
                    var index = textBoxIds.indexOf(event.target.id);
                    if (index < 0) {
                        event.preventDefault();
                    }
                }
            });

            // after drop of a token, set cursor in textbox to allow for more drag and drop tokens
            $(document).on("dragend", function (event) {
                if (isTokenDrag) {
                    var index = textBoxIds.indexOf(event.originalEvent.currentTarget.activeElement.id);
                    if (index >= 0) {
                        var textBox = event.originalEvent.currentTarget.activeElement;
                        $(textBox).selectRange(textBox.textLength);
                    }
                }
            });
        }

        // reset textcomplete
        function reinitialize() {
            if (_elements) {
                _textBoxes.forEach(textBox => {
                    _applyTextcomplete(textBox);
                });
            }
        }

        // when typing a token, offer autocomplete
        function _applyTextcomplete(textBox) {
            $(textBox).textcomplete([
                {
                    match: /{(\w*)$/,
                    search: function (term, callback) {
                        callback($.map(_elements, function (element) {
                            return element.indexOf(term) === 0 ? element : null;
                        }));
                    },
                    index: 1,
                    replace: function (element) {
                        return '{' + element + '}';
                    },
                    template: function (value) {
                        return '<span class=\"text\">' + value + '</span>';
                    }
                }
            ], { appendTo: 'body' });
        }

        //Extension function to get cursor position in Text box
        $.fn.getCursorPosition = function () {
            var el = $(this).get(0);
            var pos = 0;
            if ('selectionStart' in el) {
                pos = el.selectionStart;
            } else if ('selection' in document) {
                el.focus();
                var Sel = document.selection.createRange();
                var SelLength = document.selection.createRange().text.length;
                Sel.moveStart('character', -el.value.length);
                pos = Sel.text.length - SelLength;
            }
            return pos;
        };

        //Set cursor position
        //https://stackoverflow.com/questions/499126/jquery-set-cursor-position-in-text-area/841121#841121
        $.fn.selectRange = function (start, end) {
            if (end === undefined) {
                end = start;
            }
            return this.each(function () {
                if ('selectionStart' in this) {
                    this.selectionStart = start;
                    this.selectionEnd = end;
                } else if (this.setSelectionRange) {
                    this.setSelectionRange(start, end);
                } else if (this.createTextRange) {
                    var range = this.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', end);
                    range.moveStart('character', start);
                    range.select();
                }
            });
        };

        // Exported public API
        var exports = {
            initialize: initialize,
            reinitialize
        };

        return exports;
    }
);